<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">

        <div v-if="active" class="pure-g">
          <div class="pure-u-1-2"><h3 class="responsive">{{step}}. {{title ? title : 'Review'}}</h3></div>

          <div class="pure-u-1 spacing-20"></div>

          <div class="pure-u-1">

            <div v-for="text in summary" class="summary">
              <div class="pure-u-sm-1-4"></div>
              <div class="pure-u-1 pure-u-sm-1-2 padding-bottom-10">{{text}}</div>
            </div>

            <div class="pure-u-1 spacing-20" v-if="needAgree"></div>

            <div class="pure-u-1-24 pure-u-sm-1-4 text-right-sm" v-if="needAgree">
              <input id="agree" type="checkbox" v-model="agreed">
            </div>
            <div class="pure-u-11-12 pure-u-sm-1-2 summary" v-if="needAgree">
              <label for="agree" class="pure-checkbox" v-html="agreement"></label>
              <div class="text-red" v-if="error && !agreed">Must check box to agree.</div>
            </div>

            <div class="pure-u-1 pure-u-sm-1-4"></div>
            <div class="pure-u-1 pure-u-sm-1-2">
              <button class="pure-button pure-button-primary block padding-10 margin-10 margin-left-0" @click="success">
                {{buttonText}}
              </button>
            </div>
          </div>
        </div>

        <div v-else class="pure-u-1">
          <h3 class="responsive">{{step}}. {{title ? title : 'Review'}}</h3>
          <button v-if="canEdit && !active" v-on:click="edit" class="link-lookalike">Review</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'Review',
    data() {
      return {
        agreed: false,
        canEdit: false,
        error: false,
        agreement: store.get('review_agreement'),
        summary: store.get('review_summary'),
        buttonText: store.get('review_button_text'),
        title: store.get('review_title'),
      };
    },
    props: ['active', 'step'],
    watch: {
      active() {
        if (this.active) {
          /* global ga */
          ga('send', 'pageview', `/${store.get('subscription')}/Review`);
        }
      },
    },
    computed: {
      isSubscription() {
        return store.get('subscription') !== 'kuiuanchorage';
      },
      needAgree() {
        return this.agreement != null;
      },
    },
    methods: {
      success() {
        console.log('success clicked!');
        console.log(this.agreed || !this.needAgree);
        this.error = false;
        if (this.agreed || !this.needAgree) {
          console.log('success emitting!');
          this.$emit('success');
        } else {
          this.error = true;
        }
      },
      edit() {
        this.$emit('editView', 'Review');
      },
      setCanEdit() {
        this.canEdit = true;
      },
    },
  };
</script>


<style scoped>
  label {
    margin-top: 10px;
    margin-right: 10px;
  }

  input {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// Review.vue?d578ef78